import { render, staticRenderFns } from "./PgFormMerge.vue?vue&type=template&id=17207a18&"
import script from "./PgFormMerge.vue?vue&type=script&lang=js&"
export * from "./PgFormMerge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PgFormMerge.vue"
export default component.exports